import { CheckCircle } from 'lucide-react'
import { Card } from '@/components/ui/card'
import { cn } from '@/utilities/ui'
import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'

export function ServiceAreasBlock(props: any) {
  const { listItems: areas } = props
  return (
    <section className="w-full flex justify-center py-12" aria-label="Service Areas">
      <Card className={cn(` w-full flex flex-1 justify-center text-center overflow-hidden `)}>
        <div className="p-8">
          {props?.title && (
            <RichText
              data={props.title}
              enableGutter={false}
              enableProse={false}
              resetChildMargins
              className={cn('text-4xl font-bold text-primary leading-tight mb-6')}
            />
          )}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-center">
            {areas?.map((area: any, index: any) => {
              // Backward compatibility: if area.link is a string, treat it as custom URL
              const linkProps = (() => {
                const l = area?.link
                if (!l) return null
                if (typeof l === 'string') {
                  return { type: 'custom', url: l }
                }
                // For Payload link group { link: { type, url, reference, newTab, ... } }
                if (l && typeof l === 'object' && ('type' in l || 'url' in l || 'reference' in l)) {
                  return l as any
                }
                return null
              })()

              const content = (
                <div
                  className={cn(
                    'flex items-center text-primary gap-4 group rounded-lg transition-all duration-200 cursor-pointer',
                  )}
                >
                  <CheckCircle className="h-6 w-6 flex-shrink-0 group-hover:scale-110 transition-transform duration-200" />
                  <span className="text-lg font-medium group-hover:underline">{area.item}</span>
                </div>
              )

              return (
                <div key={index}>
                  {linkProps ? (
                    <CMSLink
                      {...linkProps}
                      appearance="inline"
                      className="no-underline"
                      renderLabelStrategy="never"
                      aria-label={area?.item}
                    >
                      {content}
                    </CMSLink>
                  ) : (
                    content
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </Card>
    </section>
  )
}
